/* RIT Performance — RESTORE
   Small theme interactions (kept framework-free).
   In Shopify these are loaded via theme.js / section assets. */
(function(){
  'use strict';

  // 1. Sticky nav shadow once user scrolls past announce bar
  var nav = document.querySelector('.nav');
  if (nav) {
    var announce = document.querySelector('.announce');
    var threshold = announce ? announce.offsetHeight : 40;
    window.addEventListener('scroll', function(){
      var y = window.scrollY || window.pageYOffset;
      if (y > threshold) nav.classList.add('nav--scrolled');
      else nav.classList.remove('nav--scrolled');
    }, { passive: true });
  }

  // 2. Smooth anchor scroll (with offset for sticky nav)
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if (id.length <= 1) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var navH = nav ? nav.offsetHeight : 0;
      var top = target.getBoundingClientRect().top + window.scrollY - navH - 12;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  // 3. FAQ: only one open at a time (progressive enhancement)
  var faqs = document.querySelectorAll('.faq__list');
  faqs.forEach(function(list){
    var items = list.querySelectorAll('.faq__item');
    items.forEach(function(item){
      item.addEventListener('toggle', function(){
        if (!item.open) return;
        items.forEach(function(other){
          if (other !== item) other.open = false;
        });
      });
    });
  });

  // 4. PDP variant selection visual
  document.querySelectorAll('[data-variant-group]').forEach(function(group){
    group.querySelectorAll('label').forEach(function(label){
      label.addEventListener('click', function(){
        group.querySelectorAll('label').forEach(function(l){
          l.classList.remove('pdp__opt--active', 'pdp__sub-opt--active');
        });
        label.classList.add(label.classList.contains('pdp__sub-opt') ? 'pdp__sub-opt--active' : 'pdp__opt--active');
      });
    });
  });

  // 5. PDP qty +/- (visual only — Shopify handles real add-to-cart)
  // Skip non-PDP qty wrappers (cart reuses the .pdp__qty class for styling but uses <input> not <span>)
  document.querySelectorAll('.pdp__qty').forEach(function(q){
    var display = q.querySelector('span');
    if (!display) return;
    var n = parseInt(display.textContent, 10) || 1;
    q.querySelector('button:first-child').addEventListener('click', function(){
      if (n > 1) n--;
      display.textContent = n;
    });
    q.querySelector('button:last-child').addEventListener('click', function(){
      if (n < 99) n++;
      display.textContent = n;
    });
  });

  // 6. PDP gallery thumb click — swap main image, and lightbox
  var mainImg = document.getElementById('pdpMainImageImg');
  var thumbs = document.querySelectorAll('.pdp__thumb');
  var lightbox = document.getElementById('pdpLightbox');
  var lightboxImg = document.getElementById('pdpLightboxImg');
  var lightboxCounter = document.getElementById('pdpLightboxCounter');
  var lightboxPrev = document.querySelector('.pdp__lightbox-prev');
  var lightboxNext = document.querySelector('.pdp__lightbox-next');
  var lightboxClose = document.querySelector('.pdp__lightbox-close');

  function pdpThumbArray(){
    return Array.prototype.slice.call(document.querySelectorAll('.pdp__thumb'));
  }
  function pdpCurrentIndex(){
    var arr = pdpThumbArray();
    for (var i=0; i<arr.length; i++){
      if (arr[i].classList.contains('pdp__thumb--active')) return i;
    }
    return 0;
  }
  function pdpSetImage(idx){
    var arr = pdpThumbArray();
    if (!arr.length) return;
    // Re-lookup elements on every call — protects against stale
    // references if the DOM was re-rendered (e.g., variant change,
    // or Shopify's internal JS replacing the gallery).
    var liveMain = document.getElementById('pdpMainImageImg');
    var liveLightboxImg = document.getElementById('pdpLightboxImg');
    var liveCounter = document.getElementById('pdpLightboxCounter');
    if (!liveMain) return;
    idx = ((idx % arr.length) + arr.length) % arr.length;
    arr.forEach(function(o){ o.classList.remove('pdp__thumb--active'); });
    arr[idx].classList.add('pdp__thumb--active');
    var url = arr[idx].getAttribute('data-media-url');
    var alt = arr[idx].querySelector('img').alt || '';
    if (url){
      liveMain.src = url;
      // Also reset srcset — the previous product image's srcset pointed
      // to the FIRST image's responsive variants, so the browser kept
      // rendering the old image despite src being updated. Replacing
      // srcset with the new image at 1200w forces the browser to use
      // the new src.
      liveMain.srcset = url + ' 1200w';
      liveMain.alt = alt;
    }
    if (liveLightboxImg && url){
      liveLightboxImg.src = url;
      liveLightboxImg.alt = alt;
    }
    if (liveCounter){
      liveCounter.textContent = (idx + 1) + ' / ' + arr.length;
    }
  }
  if (mainImg && thumbs.length){
    thumbs.forEach(function(t, i){
      t.addEventListener('click', function(){ pdpSetImage(i); });
    });
    // 6b. Click main image -> open lightbox
    mainImg.addEventListener('click', function(){
      if (!lightbox) return;
      pdpSetImage(pdpCurrentIndex());
      lightbox.classList.add('pdp__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
    // 6c. Lightbox controls
    if (lightboxClose){
      lightboxClose.addEventListener('click', function(){
        lightbox.classList.remove('pdp__lightbox--open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    }
    if (lightbox){
      // Click backdrop (but not image / buttons) -> close
      lightbox.addEventListener('click', function(e){
        if (e.target === lightbox) lightboxClose.click();
      });
    }
    if (lightboxPrev){
      lightboxPrev.addEventListener('click', function(){ pdpSetImage(pdpCurrentIndex() - 1); });
    }
    if (lightboxNext){
      lightboxNext.addEventListener('click', function(){ pdpSetImage(pdpCurrentIndex() + 1); });
    }
    // 6d. Keyboard navigation (Esc closes, arrows navigate)
    document.addEventListener('keydown', function(e){
      if (!lightbox || !lightbox.classList.contains('pdp__lightbox--open')) return;
      if (e.key === 'Escape') lightboxClose.click();
      else if (e.key === 'ArrowLeft' && lightboxPrev) lightboxPrev.click();
      else if (e.key === 'ArrowRight' && lightboxNext) lightboxNext.click();
    });
  }

  // 7. Reveal on scroll using IntersectionObserver (lite)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.promise__card, .how__step, .reviews__card, .science__row, .usage__card, .crosssell__card').forEach(function(el){
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  // 8. Brotherhood testimonial carousel — manual nav only (no autoplay, matches calm UX)
  document.querySelectorAll('[data-testimonial-track]').forEach(function(track){
    var root = track.closest('.brotherhood') || track.parentElement;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-testimonial-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-testimonial-dot]'));
    var prevBtn = root.querySelector('[data-testimonial-prev]');
    var nextBtn = root.querySelector('[data-testimonial-next]');
    if (slides.length < 2) return;

    var current = 0;

    function show(idx){
      idx = ((idx % slides.length) + slides.length) % slides.length;
      slides.forEach(function(s, i){
        var active = i === idx;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function(d, i){
        var active = i === idx;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      current = idx;
    }

    if (prevBtn) prevBtn.addEventListener('click', function(){ show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ show(current + 1); });
    dots.forEach(function(dot, i){
      dot.addEventListener('click', function(){ show(i); });
    });

    // Keyboard arrows when carousel is in viewport
    document.addEventListener('keydown', function(e){
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  });

  // 9. Cart: +/- buttons drive standard Shopify cart form (updates[] + name="remove")
  // The form does all the work natively — updates get POSTed to /cart, server returns
  // 302 → /cart, browser reloads with the refreshed cart HTML.
  document.querySelectorAll('[data-cart-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var wrap = btn.closest('.pdp__qty') || btn.closest('.cart__qty');
      var input = wrap ? wrap.querySelector('[data-cart-qty-input]') : null;
      if (!input || !btn.form) return;
      var n = parseInt(input.value, 10) || 0;
      var delta = parseInt(btn.getAttribute('data-cart-qty'), 10) || 0;
      n = Math.max(0, Math.min(99, n + delta));
      input.value = n;
      btn.form.submit();
    });
  });

  // Remove button — uses /cart/change.js with quantity:0 (more reliable than form-based remove)
  document.querySelectorAll('[data-cart-remove]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var key = btn.getAttribute('data-cart-remove');
      if (!key) return;
      btn.setAttribute('disabled', 'disabled');
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(){ location.reload(); })
      .catch(function(){
        // Fallback: standard form-based remove via a synthetic form submit
        var f = document.createElement('form');
        f.method = 'post';
        f.action = '/cart';
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'remove';
        i.value = key;
        f.appendChild(i);
        document.body.appendChild(f);
        f.submit();
      });
    });
  });

  // Sanitize digits in the qty input, then submit on change/Enter (so typing actually updates)
  document.querySelectorAll('[data-cart-qty-input]').forEach(function(input){
    input.addEventListener('input', function(){
      var cleaned = input.value.replace(/[^0-9]/g, '');
      if (cleaned.length > 2) cleaned = cleaned.slice(0, 2);
      if (cleaned !== input.value) input.value = cleaned;
    });
    input.addEventListener('change', function(){
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = 0;
      n = Math.max(0, Math.min(99, n));
      input.value = n;
      if (input.form) input.form.submit();
    });
    input.addEventListener('blur', function(){
      if (input.value === '') input.value = '0';
    });
    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter'){ e.preventDefault(); if (input.form) input.form.submit(); }
    });
  });

  // 10. Review form auto-helper — builds a "ready to paste" review block
  //     in a hidden field as the user fills out the review form. When the
  //     form submits, Shopify includes this value in the email body so the
  //     merchant can copy it directly into a Review block in the theme
  //     editor. Stars use the same ★ character as the existing review cards.
  try {
    document.querySelectorAll('[data-review-paste]').forEach(function(pasteField){
      var form = pasteField.form;
      if (!form) return;

      // Look up the form's input fields by name (stable across the form
      // regardless of where it lives in the DOM).
      function findField(name){
        return form.querySelector('[name="contact[' + name + ']"]:not([type="hidden"])');
      }
      var nameField  = findField('name');
      var roleField  = findField('role');
      var ratingField = findField('rating');
      var bodyField  = findField('body');

      function starsFor(n){
        n = parseInt(n, 10);
        if (n === 5) return '★★★★★';
        if (n === 4) return '★★★★☆';
        if (n === 3) return '★★★☆☆';
        if (n === 2) return '★★☆☆☆';
        if (n === 1) return '★☆☆☆☆';
        return '—';
      }

      function build(){
        var name   = nameField   ? nameField.value.trim()   : '';
        var role   = roleField   ? roleField.value.trim()   : '';
        var rating = ratingField ? ratingField.value.trim() : '';
        var body   = bodyField   ? bodyField.value.trim()   : '';

        // Skip building the helper if the user hasn't actually filled out
        // anything substantive. This keeps the email body clean if someone
        // hits Submit by accident.
        if (!rating && !body && !name) {
          pasteField.value = '';
          return;
        }

        var stars = starsFor(rating);
        var ratingLine = rating ? (stars + ' (' + rating + '/5)') : '— (no rating given)';
        var nameLine = name || '(no name given)';
        if (role) nameLine += ' · ' + role;

        var block = [
          'Rating: ' + ratingLine,
          'Name: '   + nameLine,
          'Headline: (write a 3–7 word pull-quote)',
          'Body: '   + (body || '(no body given)'),
          '',
          '--- Copy this into theme editor → product section → Reviews → Add block ---',
          'Rating stars: ' + stars,
          'Headline: (write a 3–7 word pull-quote)',
          'Body: ' + (body || '(no body given)'),
          'Author: ' + (name || '(no name given)'),
          'Role: '   + role
        ].join('\n');

        pasteField.value = block;
      }

      // Update on every keystroke / change. Cheap; tiny string.
      [nameField, roleField, ratingField, bodyField].forEach(function(f){
        if (!f) return;
        f.addEventListener('input',  build);
        f.addEventListener('change', build);
      });

      // Build once on initial render too (in case the form is re-rendered
      // with form.* values populated, e.g. after a failed submit).
      build();
    });
  } catch (e) {
    if (window.console && console.warn) console.warn('Review paste helper failed:', e);
  }

  // 11. Newsletter form — show success/error state based on URL fragment.
  //     The default Shopify {% form 'customer' %} posts to /contact with a
  //     hidden return_to field that points back here with #newsletter-form.
  //     When the page reloads, JS detects the fragment, hides the form
  //     fields, and shows a success/error message inline. No fetch, no
  //     CORS, no Cloudflare issues — the form just works like a normal
  //     HTML form.
  try {
    var hash = window.location.hash;
    // We use #newsletter-form as the success hash. If a future change needs
    // to distinguish success from error, we can add separate fragments.
    if (hash === '#newsletter-form') {
      var form = document.querySelector('form.newsletter__form-wrap');
      if (form) {
        // Show success (the customer form only redirects back on success;
        // errors stay on /contact with the form re-rendered there).
        renderNewsletterStatus(form, 'success',
          "You're on the list.", 'Watch your inbox for the next drop.');
        // Smooth-scroll the form into view (overrides the browser's instant jump)
        setTimeout(function(){
          var navH = document.querySelector('.nav') ? document.querySelector('.nav').offsetHeight : 0;
          var top = form.getBoundingClientRect().top + window.scrollY - navH - 12;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }, 50);
      }
    }

    function renderNewsletterStatus(form, kind, title, body){
      // Hide the form fields but keep the wrapper so the success message
      // appears in the same spot.
      var formEl = form.querySelector('.newsletter__form');
      if (formEl) formEl.style.display = 'none';

      // Remove any existing status so we don't stack them
      var existing = form.querySelector('.newsletter__status');
      if (existing) existing.parentNode.removeChild(existing);

      var status = document.createElement('div');
      status.className = 'newsletter__status newsletter__status--' + kind;
      status.setAttribute('role', kind === 'success' ? 'status' : 'alert');
      var titleEl = document.createElement('strong');
      titleEl.textContent = title;
      status.appendChild(titleEl);
      if (body) {
        var bodyEl = document.createElement('span');
        bodyEl.textContent = ' ' + body;
        status.appendChild(bodyEl);
      }
      form.appendChild(status);
    }
  } catch (e) {
    if (window.console && console.warn) console.warn('Newsletter status render failed:', e);
  }

  // 12. Video block — click-to-play overlay. The <video> element has
  //     preload="none" so it doesn't load until the user clicks. Native
  //     controls take over after that. We also swap to the smaller (480p)
  //     source on mobile / slow connections to save bandwidth.
  try {
    document.querySelectorAll('[data-video-block]').forEach(function(frame){
      var video  = frame.querySelector('video');
      var play   = frame.querySelector('[data-video-play]');
      if (!video || !play) return;

      var src720 = video.getAttribute('data-video-720');
      var src480 = video.getAttribute('data-video-480');

      // Pick the source based on a quick connection check. Network
      // Information API is supported in most modern browsers; if it's
      // not available, default to 720p.
      function pickSource(){
        if (!src480) return;
        var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!conn) return;
        // effectiveType is 'slow-2g' | '2g' | '3g' | '4g'. 4g gets 720,
        // anything else gets 480. saveData also forces 480.
        if (conn.saveData) return swap(src480);
        if (conn.effectiveType && conn.effectiveType !== '4g') return swap(src480);
      }
      function swap(url){
        if (!url) return;
        var sources = video.querySelectorAll('source');
        for (var i = 0; i < sources.length; i++) {
          sources[i].setAttribute('src', url);
        }
        video.load();
      }
      pickSource();

      play.addEventListener('click', function(){
        // Show native controls and play. We don't remove the overlay
        // outright — the browser's controls cover it, and the user can
        // click pause via the native UI.
        play.classList.add('is-hidden');
        video.controls = true;
        // Some browsers require a play() call AFTER setting src via the
        // click handler. Try, swallow the rejection.
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function(){});
      });

      // If the user pauses the video, show the play overlay again so
      // they can resume. video.paused flips true on pause.
      video.addEventListener('pause', function(){
        if (video.currentTime === 0 || video.ended) {
          play.classList.remove('is-hidden');
        }
      });
    });
  } catch (e) {
    if (window.console && console.warn) console.warn('Video block init failed:', e);
  }
})();
